import UploadModal from "./upload-modal";

export default UploadModal;
